import { Component, HostListener, OnInit } from '@angular/core';
import { InviteMemberComponent } from '../popups/invite-member/invite-member.component';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CheckScreenComponent } from '../popups/check-screen/check-screen.component';
import { SIZE_SCREEN } from 'src/app/utils/const';
import { Observable } from 'rxjs';
import { ShareService } from 'src/app/data/service/share.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  constructor(private modalService: BsModalService,
    private shareService: ShareService,
    private httpClient: HttpClient,
    private router: Router

  ) { }
  
  isInDashboard(): boolean {
    return window.location.href.includes('dashboard');
  }

  ngOnInit(): void {
    this.checkHostDeviceScreen();
  }

  onInvite(): void {
    const config: ModalOptions = { class: 'modal-lg modal-dialog-centered' };
    this.modalService.show(InviteMemberComponent, config);
  }

  SimpleSendTokensToApi(): Observable<any> {
    let authData = this.shareService.getSession();
    if (!authData) {
      this.router.navigate(['/auth/login/']);
    }
    let body: any = {
      accessToken: authData.access_token,
      refreshToken: authData.refresh_token,
    };
    return this.httpClient.post<any>(
      this.shareService.apiBaseURL +
      '/api/v1/organizations/users/SaveOauthTokens',
      body
    );
  }

  @HostListener('window:resize', ['$event'])
  checkHostDeviceScreen(event = null) {
    if (window.innerWidth < SIZE_SCREEN) {
      this.openModalScreen();
      if (this.isInDashboard()) { 
        this.SimpleSendTokensToApi().subscribe((authCode: string) => {
          const orgId = this.shareService.organizationSelected.id;
          const gotoUrl = `${environment.mayaRedirect}/?code=${authCode}&organizationId=${orgId}`;
            window.location.replace(gotoUrl);
        });
      }
    } else {
      this.modalService.hide();
    }
  }

  openModalScreen(): void {
    const config: ModalOptions = {
      class: 'modal-lg modal-dialog-centered',
      backdrop: 'static',
    };
    this.modalService.show(CheckScreenComponent, config);
  }
}

